module.exports = __webpack_public_path__ + "static/swatch-c1b8b8d06930d845b368f34929dc1afb.png";